export const ACTION_SET_USER_TYPE = "ACTION_SET_USER_TYPE";
export const IS_APPICANT_TYPE_OTHERS = "IS_APPICANT_TYPE_OTHERS";
